<div class="all" mat-dialog-content style="padding: 0 6vw">
  <lemon-dialog-header [naytaSuljeRuksi]="false" [naytaOtsikko]="false"></lemon-dialog-header>
  <div class="big-card">
    <div class="light-blue-text title-text">{{ 'general-bank-selection.pankkiyhteysvaltuutus' | translate | async }}</div>
    <div class="inner-container">
      <div class="text-box" [class.subselection-active]="!!expandedAiiaBank() || !!expandedEbBank()">
        @if (!expandedAiiaBank() && !expandedEbBank()) {
          <div style="margin-bottom: 40px">
            {{ valtuutusStartText }}
          </div>
        }

        <div class="idp-container">
          @for (entry of naytettavatPankit(); track entry.key) {
            @if (!entry.disabled) {
              <button mat-button (click)="onBankClick(entry.key)">
                <span class="organization-logo"><img [src]="entry.logo" alt="" /></span>
                <span class="organization-name">{{ entry.name }}</span>
              </button>
            }
          }
        </div>

        @if (expandedAiiaBank()) {
          <div>
            <div class="selected-bank-header">
              <div class="selected-bank-label">{{ 'general-bank-selection.valittu-pankki' | translate | async }}</div>
              <div class="selected-bank-logo mat-elevation-z1">
                <img [src]="dialogConfig[expandedAiiaBank()].logo" alt="" />
              </div>
            </div>
            <div class="account-type-prompt" id="select-account-type-header">
              {{ 'general-bank-selection.valitse-tilin-tyyppi' | translate | async }}
            </div>
            <form class="picker-form">
              <mat-chip-listbox class="psu-chip-listbox" aria-labelledby="select-account-type-header" [formField]="lomake.accountType">
                <mat-chip-option [value]="expandedAiiaBank() + '-personal'">{{ 'general-bank-selection.yksityistili' | translate | async }}</mat-chip-option>
                <mat-chip-option [value]="expandedAiiaBank() + '-business'">{{ 'general-bank-selection.yritystili' | translate | async }}</mat-chip-option>
                @if (expandedAiiaBank() === 'nordea') {
                  <mat-chip-option [value]="expandedAiiaBank() + '-corporate'">{{ 'general-bank-selection.corporate' | translate | async }}</mat-chip-option>
                }
              </mat-chip-listbox>
            </form>
          </div>
        }

        @if (expandedEbBank()) {
          <div>
            <span class="organization-logo"><img [src]="dialogConfig[expandedEbBank()].logo" alt="" /></span>
            <div class="account-type-prompt" id="select-bank-type-header">
              {{ 'general-bank-selection.valitse-pankin-tyyppi' | translate | async }}
            </div>
            <form class="picker-form">
              <!-- Ei [formField]-sidontaa: valitun sirun uusi painallus antaa arvon undefined, joka poistaisi kentän Signal Formsista -->
              @if (currentEbSubtypes()?.length > 1) {
                <mat-chip-listbox aria-labelledby="select-bank-type-header" [value]="lomake.ebSubtypeName().value()" (change)="onSubtypeSelected($event.value)">
                  @for (subType of currentEbSubtypes(); track subType.name) {
                    <mat-chip-option [value]="subType.name">{{ subType.name }}</mat-chip-option>
                  }
                </mat-chip-listbox>
              }
              @if (selectedEbSubtype()?.psuTypes?.length) {
                <mat-chip-listbox class="psu-chip-listbox" [attr.aria-label]="'general-bank-selection.valitse-tilin-tyyppi' | translate | async" [value]="lomake.ebPsuType().value()" (change)="lomake.ebPsuType().value.set($event.value ?? null)">
                  @for (option of selectedEbSubtype().psuTypes; track option.psuType) {
                    <mat-chip-option [value]="option.psuType">{{ option.labelKey | translate | async }}</mat-chip-option>
                  }
                </mat-chip-listbox>
              }
            </form>
          </div>
        }

        @if (commonError()) {
          <div class="red-text common-error">{{ commonError() }}</div>
        }

        <div #selitys class="gray-text valtuutus-extra-text" [hidden]="!extraTextExpanded" [innerHTML]="'viia-login-required.valtuutus-pitka-selitus' | translate | async"></div>
      </div>
    </div>
    @if (!expandedAiiaBank() && !expandedEbBank()) {
      <div style="margin-bottom: 1em; display: flex; justify-content: center">
        <button class="primarybutton" mat-button (click)="closeDialog()">
          {{ 'yleiset.sulje' | translate | async }}
        </button>
      </div>
    } @else {
      @if (expandedAiiaBank()) {
        <div class="action-buttons">
          <button class="secondarybutton" mat-button (click)="backToFullList()">
            {{ 'yleiset.takaisin' | translate | async }}
          </button>
          <button class="primarybutton" mat-button (click)="getAccountTypeStartAiiaFlow()">
            {{ 'yleiset.jatka' | translate | async }}
          </button>
        </div>
      }
      @if (expandedEbBank()) {
        <div class="action-buttons">
          <button class="secondarybutton" mat-button (click)="backToFullList()">
            {{ 'yleiset.takaisin' | translate | async }}
          </button>
          <button class="primarybutton" mat-button (click)="startEbPsuTypeFlow()" [disabled]="!lomake.ebPsuType().value()">
            {{ 'yleiset.jatka' | translate | async }}
          </button>
        </div>
      }
    }
  </div>
</div>
